import { IQuestionTag } from '../question-tag';
import { IQuestion } from './question.types';

export class Choice {
  id?: number;
  text?: string;
  item?: number;
  inclusion_rules?: Rule[];
  exclusion_rules?: Rule[];
  note?: string;
  quantity?: number;

  constructor() {
    this.quantity = 1;
  }
}

export class Rule {
  id?: number;
  module?: number; //readonly
  question?: number; //readonly
  selected_choice?: number;
}

export class ValueOption {
  id?: number;
  item?: number;
  min_value?: number;
  max_value?: number;
  note?: string;
  quantity?: number;
  computation?: Computation;

  constructor() {
    this.quantity = 1;
  }
}
export class Question implements IQuestion {
  id?: number;
  text?: string;
  hint?: string;
  type?: number;
  order?: number;
  module?: number;
  item_required?: boolean;
  // TODO: 2021-01-04 -LH - Should be initialized? if yes should be in constructor
  compute_quantity?: boolean = false;
  choices?: NewChoice[];
  value_option?: ValueOption | null;
  errors?: string[];
  tags: IQuestionTag[];
  constructor() {
    this.value_option = new ValueOption();
    this.choices = [];
    this.tags = [];
  }
}

export class NewChoice {
  id?: number;
  text?: string;
  item?: number;
  quantity?: number = 1;
  note?: string;
  rule?: NewRule;
  computation?: Computation;
  order?: number;

  constructor(choice?: NewChoice) {
    this.rule = choice?.rule;
    this.computation = choice?.computation;
    this.order = choice?.order;
  }
}

export class SubRule {
  id?: number;
  readonly module?: number | null;
  readonly question?: number | null;
  choice?: number;

  constructor(subRule?: SubRule) {
    this.module = subRule?.module;
    this.question = subRule?.question;
    this.id = subRule?.id;
    this.choice = subRule?.choice;
  }
}

export class RuleGroup {
  id?: number;
  sub_rules?: SubRule[] = [];
}

export class NewRule {
  id?: number;
  type? = 1;
  rule_groups?: RuleGroup[] = [];
}

// 0 - Equal
// 1 - Add
// 2 - Subtract
// 3 - Multiply
// 4 - Divide

export enum Operation {
  ASSIGN = 0,
  COMPUTE = 1
}

export enum OperandType {
  CONSTANT = 0,
  VARIABLE = 1,
  NONE = 2
}

export class Operand {
  id?: number;
  type?: number = OperandType.VARIABLE;
  constant?: number;
  order?: number;
  readonly module?: number | null;
  readonly question?: number | null;

  constructor(operand?: Operand) {
    this.module = operand?.module;
    this.question = operand?.question;
    this.id = operand?.id;
    this.type = operand?.type;
    this.constant = operand?.constant;
    this.order = operand?.order;
  }
}

export class Operator {
  id?: number;
  symbol?: string;

  constructor(operator?: Operator) {
    this.id = operator?.id;
    this.symbol = operator?.symbol;
  }
}

export class Computation {
  id?: number;
  operation?: number = Operation.ASSIGN;
  operands?: Operand[] = [];
  operators?: Operator[] = [];
}

export enum QuestionType {
  Value = 0,
  MultipleChoice = 1,
  NumericChoice = 2
}
